module.exports = __webpack_public_path__ + "media/images/bank_images/caixa-1e2ca8bdd9d960578ab59ceed5a93d58.png";